import { render, staticRenderFns } from "./ReachTab.vue?vue&type=template&id=4170896a&"
import script from "./ReachTab.vue?vue&type=script&lang=js&"
export * from "./ReachTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports